




























































import _ from 'lodash';
import {Component, Vue} from 'vue-property-decorator';
import {DxPopup, DxList, DxDateBox, DxCheckBox} from 'devextreme-vue';
import {alert, confirm} from 'devextreme/ui/dialog';

import DButton from '@/components/DButton/button.vue';
import BackupScheduleService, {BackupSchedule} from '@/services/data/backup_schedule';
import {days} from '@/services/singleton-service';
import {IResponseResult} from '@/services/data/base_types';
import {
  getUTCHoursAndMinutesAsString, correctDaysOfWeekByTimeZoneOnSave, correctDaysOfWeekByTimeZoneOnLoad
} from '@/utils/datetime';

interface IBackupScheduleEditing {
  days_of_week: number[];
  time: Date | null;
  run_once: boolean;
}

@Component({
  name: 'BackupScheduleEditPopup',
  components: {
    DxPopup,
    DxList,
    DxDateBox,
    DxCheckBox,
    DButton
  }
})
export default class extends Vue {
  private service = BackupScheduleService;
  private days = days;
  private entity: IBackupScheduleEditing = {
    days_of_week: [],
    time: null,
    run_once: false
  };

  private get somethingChanged(): boolean {
    return this.service.edit_mode
      ? JSON.stringify(correctDaysOfWeekByTimeZoneOnSave(this.entity.days_of_week, this.entity.time)) !==
      this.service.selected_row?.days_of_week ||
      getUTCHoursAndMinutesAsString(this.entity.time) !== this.service.selected_row?.time ||
      this.entity.run_once !== this.service.selected_row?.run_once
      : this.entity.days_of_week.length > 0 || !!this.entity.time || this.entity.run_once;
  }

  private onShowing(): void {
    if (this.service.edit_mode && this.service.selected_row) {
      const aDate = new Date();
      const timeStr = this.service.selected_row.time.split(':');
      aDate.setUTCHours(Number.parseInt(timeStr[0]), Number.parseInt(timeStr[1]));
      this.entity.time = aDate;
      this.entity.days_of_week = correctDaysOfWeekByTimeZoneOnLoad(JSON.parse(this.service.selected_row.days_of_week), aDate)
      this.entity.run_once = this.service.selected_row.run_once;
    } else {
      this.entity.days_of_week = [];
      this.entity.time = null;
      this.entity.run_once = false;
    }
  }

  private onSave(): void {
    if (!this.somethingChanged) {
      this.service.setEditPopupVisible(false);
      return;
    }

    const error = this.validationError();
    if (error) {
      alert(error, 'Ошибка');
      return;
    }

    if (this.entity) {
      const entityToSave = this.service.edit_mode
        ? (this.service.selected_row ? _.cloneDeep(this.service.selected_row) : new BackupSchedule())
        : new BackupSchedule();
      entityToSave.time = getUTCHoursAndMinutesAsString(this.entity.time);
      entityToSave.days_of_week = JSON.stringify(
        correctDaysOfWeekByTimeZoneOnSave(this.entity.days_of_week, this.entity.time)
      );
      entityToSave.run_once = this.entity.run_once;
      this.service.save(entityToSave)
        .then((response: IResponseResult<BackupSchedule>) => {

          if (response.data) {
            this.service.dataSource.reload().catch((reason: any) => { if (reason !== 'canceled') throw reason; });
            this.service.setEditPopupVisible(false);
          } else if (response.message) {
            alert(response.message, 'Ошибка сохранения');
          }
        });
    }
  }

  private onCancel(): void {
    if (this.somethingChanged) {
      confirm('Закрыть без сохранения?', '')
        .then((answer: boolean) => {
          if (answer) {
            this.service.setEditPopupVisible(false);
          }
        });
    } else {
      this.service.setEditPopupVisible(false);
    }
  }

  private validationError(): string {
    if (this.entity) {
      if (this.entity.days_of_week.length < 1) {
        return 'Необходимо выбрать дни недели';
      } else if (!this.entity.time) {
        return 'Необходимо задать время запуска';
      }
      return '';
    }
    return 'Пустое расписание';
  }
}
